import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Oak barrel with iron hoops — outdoor twin of structure furniture barrel.
// Landmark prop (weight 0 in content). Geometry only.
const build: (ctx: DecoBuildCtx) => void = ({ cylinder, seed }) => {
  const wood = shade(0x8a6f4d, (rand(seed) - 0.5) * 0.12);
  const iron = shade(0x4a4a4e, (rand(seed + 1) - 0.5) * 0.08);
  cylinder(0, 0, 0, 0.34, 0.38, 0.32, wood);
  cylinder(0, 0.32, 0, 0.43, 0.43, 0.42, wood);
  cylinder(0, 0.74, 0, 0.4, 0.34, 0.32, wood);
  cylinder(0, 0.22, 0, 0.44, 0.44, 0.07, iron);
  cylinder(0, 0.74, 0, 0.41, 0.41, 0.07, iron);
  cylinder(0, 1.04, 0, 0.33, 0.33, 0.06, shade(wood, -0.12));
};

export default build;
